import { Routes } from '@angular/router';

import { featureFlagGuard } from './core/config/feature-flag.guard';
import { demoOrSessionGuard } from './core/demo/demo-session.guard';
import { errorRoutes } from './features/error/error.routes';
import { HomeComponent } from './features/home/home.component';
import { loginRoutes } from './features/login/routes/login.routes';
import { passwordResetRoutes } from './features/password-reset/password-reset.routes';
import { ShellComponent } from './features/shell/shell.component';

export const routes: Routes = [
  ...loginRoutes,
  ...passwordResetRoutes,
  {
    path: 'demo',
    canMatch: [featureFlagGuard('demo')],
    loadComponent: () =>
      import('./core/demo/demo-entry.component').then((module) => module.DemoEntryComponent),
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [demoOrSessionGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'actions' },
      { path: 'home', component: HomeComponent },
      {
        path: 'actions',
        loadChildren: () =>
          import('./features/actions/actions.routes').then((module) => module.ACTIONS_ROUTES),
      },
      {
        path: 'clients',
        loadChildren: () =>
          import('./features/clients/clients.routes').then((module) => module.CLIENTS_ROUTES),
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./features/profile/profile.routes').then((module) => module.PROFILE_ROUTES),
      },
      {
        path: 'materials',
        canMatch: [featureFlagGuard('materials')],
        loadChildren: () =>
          import('./features/materials/materials.routes').then((module) => module.MATERIALS_ROUTES),
      },
    ],
  },
  { path: 'error', children: errorRoutes },
  { path: '**', redirectTo: 'actions' },
];
